<script>
/**
 * @overview 二级菜单选择
 *
 * @author retro
 */

export default {
  name: "MenuItem",

  props: {
    data: {
      type: Array,
      required: true,
    },

    value: {
      type: [String, Number],
      default: null,
    },
  },

  methods: {
    chooseItem(value) {
      this.$emit("input", value);
      this.$emit("change", value);
    },
  },
};
</script>

<template>
  <div class="v-radio-text">
    <span
      v-for="item in data"
      :key="item.id"
      :class="{
        'v-radio-text__item': true,
        'v-radio-text__item--active': `${item.id}` === `${value}`,
      }"
      @click.stop="() => chooseItem(item.id)"
    >
      {{ item.value }}
    </span>
  </div>
</template>

<style lang="postcss" scoped>
.v-radio-text {
  display: flex;
}

.v-radio-text__item {
  padding: 1em 0;
  text-align: center;
  color: var(--font-color-default);
  cursor: pointer;
}

.v-radio-text__item:not(:last-child) {
  margin-right: 2em;
}

.v-radio-text__item:hover,
.v-radio-text__item--active {
  color: var(--font-color-active);
}
</style>
